var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4.86C18.77 7.06 18.77 10.11 16.75 12.13L15.07 10.44C15.91 9.26 15.91 7.73 15.07 6.55L16.75 4.86ZM20.06 1.5C24 5.55 23.96 11.61 20.06 15.5L18.43 13.87C21.2 10.69 21.2 6.15 18.43 3.13L20.06 1.5ZM13.36 14.26C15.31 14.92 17 16 17 17.5V22.5H1V17.5C1 16 2.69 14.92 4.65 14.26L5.27 15.5L5.5 16C4 16.46 2.9 17.12 2.9 17.5V20.6H7.12L8 15.53L7.06 13.65C7.68 13.58 8.33 13.53 9 13.53C9.67 13.53 10.32 13.58 10.94 13.65L10 15.53L10.88 20.6H15.1V17.5C15.1 17.12 14 16.46 12.5 16L12.73 15.5L13.36 14.26ZM9 6.5C7.9 6.5 7 7.4 7 8.5C7 9.6 7.9 10.5 9 10.5C10.1 10.5 11 9.6 11 8.5C11 7.4 10.1 6.5 9 6.5ZM9 12.5C6.79 12.5 5 10.71 5 8.5C5 6.29 6.79 4.5 9 4.5C11.21 4.5 13 6.29 13 8.5C13 10.71 11.21 12.5 9 12.5Z",
    fill: "#7B809A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeak);
export default __webpack_public_path__ + "static/media/speak.f1700018f13219106331fa36f797d78f.svg";
export { ForwardRef as ReactComponent };